import { useState, useEffect } from "react";

const BASE = process.env.REACT_APP_API_URL || (window.location.hostname === "localhost" ? "http://localhost:8000" : "https://nashman-prod-production-c773.up.railway.app");

export default function ResetPassword() {
  const [token,    setToken]    = useState("");
  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (t) setToken(t);
    else setError("Invalid reset link. Please request a new one.");
  }, []);

  const handleReset = async () => {
    setError("");
    if (!password)            return setError("Password cannot be empty.");
    if (password.length < 6)  return setError("Password must be at least 6 characters.");
    if (password !== confirm)  return setError("Passwords do not match.");
    setLoading(true);
    try {
      const res  = await fetch(`${BASE}/auth/reset-password`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (res.ok) setSuccess(true);
      else setError(data.detail || "Reset failed. Link may have expired.");
    } catch { setError("Network error. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFC", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: "36px 32px", width: "100%", maxWidth: 400, boxShadow: "0 4px 24px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ width: 52, height: 52, background: "#0F172A", borderRadius: 14, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
            <span style={{ color: "#fff", fontSize: 26, fontWeight: 800 }}>N</span>
          </div>
          <div style={{ fontWeight: 700, fontSize: 18, color: "#0F172A" }}>Nashman Institute EMR</div>
          <div style={{ fontSize: 13, color: "#64748B", marginTop: 4 }}>Reset Admin Password</div>
        </div>

        {success ? (
          <div>
            <div className="alert alert-green" style={{ marginBottom: 20 }}>✓ Password reset successfully!</div>
            <p style={{ fontSize: 13, color: "#64748B", textAlign: "center", marginBottom: 20 }}>You can now log in with your new password.</p>
            <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
              onClick={() => window.location.href = "/"}>Go to Login</button>
          </div>
        ) : (
          <div>
            {error && <div className="alert alert-red" style={{ marginBottom: 16 }}>{error}</div>}
            {token && (
              <div>
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 6 characters" autoFocus />
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm Password</label>
                  <input className="input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password"
                    onKeyDown={e => e.key === "Enter" && handleReset()} />
                </div>
                <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginTop: 8 }}
                  disabled={loading || !password || !confirm} onClick={handleReset}>
                  {loading ? "Resetting..." : "Set New Password"}
                </button>
              </div>
            )}
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <a href="/" style={{ fontSize: 13, color: "#64748B" }}>← Back to Login</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
